<router-outlet *ngIf="!loading; else loader"></router-outlet>

<ng-template #loader>
  <div class="screen-center">
    <div class="loader"></div>
  </div>
</ng-template>
